import { Icon } from "../../../../../Components/Icon";
import { projectName } from "../../../../../settings";

export type MessagingUserCategory = {
	id: string;
	name: string;
	description: string;
	Icon: (props: Icon.IconProps) => JSX.Element | null;
	iconColor?: string;
	iconBackgroundColor?: string;
	members: MessagingUserCategoryMember[];
};

export type MessagingUserCategoryMember = {
	description: string;
	email: string;
};

export const userCategories = ((): MessagingUserCategory[] => {
	if (projectName === "verita-romania") {
		return [
			{
				id: "General",
				name: "General",
				description: "For General Questions, Comments, Feedback And Requests",
				Icon: Icon.Question,
				iconColor: "var(--theme-colors__blue)",
				iconBackgroundColor: "var(--theme-colors__blue--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "tamara.eftene@verita.ro",
					},
					{
						description: "Early Years School",
						email: "mari.matei@verita.ro",
					},
					{
						description: "Schoolwide Issues, Policy And Development",
						email: "lila.vasilescu@verita.ro",
					},
					{
						description: "Schoolwide Issues, Policy And Development",
						email: "luiza.joita@verita.ro",
					},
				],
			},
			{
				id: "Education",
				name: "Education",
				description: "For Questions Relating To Educational Policies, Issues, Organization And Routines",
				Icon: Icon.Exam,
				iconColor: "var(--theme-colors__orange)",
				iconBackgroundColor: "var(--theme-colors__orange--background)",
				members: [
					{
						description: "Early Years And Primary School",
						email: "april.wuest@verita.ro",
					},
					{
						description: "Early Years And Primary School",
						email: "julie.dinca@verita.ro",
					},
					{
						description: "Secondary School",
						email: "ashley.peek@verita.ro",
					},
					{
						description: "Secondary School",
						email: "irina.cazacu@verita.ro",
					},
				],
			},
			{
				id: "Financial",
				name: "Financial",
				description: "For Questions Relating To General Finance And Payments",
				Icon: Icon.Bank,
				iconColor: "var(--theme-colors__green)",
				iconBackgroundColor: "var(--theme-colors__green--background)",
				members: [
					{
						description: "Finance, Payments And Accounting",
						email: "Alexandra.sarealba@verita.ro",
					},
				],
			},
			{
				id: "Curriculum",
				name: "Curriculum",
				description: "For Questions Regarding Curriculum, Syllabus, Content And Misc.",
				Icon: Icon.BookOpenText,
				iconColor: "var(--theme-colors__yellow)",
				iconBackgroundColor: "var(--theme-colors__yellow--background)",
				members: [
					{
						description: "Early Childhood Curriculum",
						email: "roxana.din@verita.ro",
					},
					{
						description: "Primary & Secondary School Curriculum",
						email: "nom.such@verita.ro",
					},
					{
						description: "IMYC Curriculum",
						email: "georgeta.gherghinoiu@verita.ro",
					},
					{
						description: "IBDP Curriculum",
						email: "marco.fick@verita.ro",
					},
					{
						description: "Modern Languages Curriculum",
						email: "diana.mihalache@verita.ro",
					},
				],
			},
			{
				id: "Guidance & Counseling",
				name: "Guidance & Counseling",
				description: "For Questions Relating To General Counseling, College Counseling And Guidance Counseling",
				Icon: Icon.Compass,
				iconColor: "var(--theme-colors__purple)",
				iconBackgroundColor: "var(--theme-colors__purple--background)",
				members: [
					{
						description: "Early Year And Primary School Counseling",
						email: "ana.abatacesei@verita.ro",
					},
					{
						description: "Secondary School Counseling",
						email: "ilinca.vlaicu@verita.ro",
					},
				],
			},
			{
				id: "SEL & Learning Support",
				name: "SEL & Learning Support",
				description: "For Questions And Support Regarding Social Emotional Or General Learning",
				Icon: Icon.FlowerLotus,
				iconColor: "var(--theme-colors__teal)",
				iconBackgroundColor: "var(--theme-colors__teal--background)",
				members: [
					{
						description: "SEL and Learning Support",
						email: "andreea.alexandrescu@verita.ro",
					},
				],
			},
			{
				id: "After-School",
				name: "After-School",
				description: "For Questions Relating To After School Activities",
				Icon: Icon.SoccerBall,
				iconColor: "var(--theme-colors__orange)",
				iconBackgroundColor: "var(--theme-colors__orange--background)",
				members: [
					{
						description: "After School Activities And Workshops",
						email: "cristina.mica@verita.ro",
					},
				],
			},

			{
				id: "Transportation",
				name: "Transportation",
				description: "For Questions Relating To Transportation",
				Icon: Icon.Van,
				iconColor: "var(--theme-colors__blue)",
				iconBackgroundColor: "var(--theme-colors__blue--background)",
				members: [
					{
						description: "",
						email: "cristina.mica@verita.ro",
					},
				],
			},
			{
				id: "Health",
				name: "Health",
				description: "For Questions Relating To Health And Health Issues",
				Icon: Icon.FirstAidKit,
				iconColor: "var(--theme-colors__pink)",
				iconBackgroundColor: "var(--theme-colors__pink--background)",
				members: [
					{
						description: "EY & Y1 Nurse",
						email: "ionela.obreja@verita.ro",
					},
					{
						description: "Primary & Secondary Nurse",
						email: "tanta.dragoi@verita.ro",
					},
				],
			},
			{
				id: "Food",
				name: "Food",
				description: "For Questions Regarding Food, Meal Menus And Misc.",
				Icon: Icon.ForkKnife,
				iconColor: "var(--theme-colors__orange)",
				iconBackgroundColor: "var(--theme-colors__orange--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "tamara.eftene@verita.ro",
					},
					{
						description: "Early Years School General",
						email: "mari.matei@verita.ro",
					},
				],
			},
			{
				id: "Technology",
				name: "Technology",
				description: "For Questions Relating To Technology Policies, Hardware Advice And General Troubleshooting",
				Icon: Icon.Desktop,
				iconColor: "var(--theme-colors__teal)",
				iconBackgroundColor: "var(--theme-colors__teal--background)",
				members: [
					{
						description: "Verita Portal Troubleshooting & Feedback ",
						email: "jett@hexinsights.com",
					},
					{
						description: "General I.T & Technology",
						email: "ciprian.bulmaga@verita.ro",
					},
				],
			},
			{
				id: "Admissions & Withdrawals",
				name: "Admissions & Withdrawals",
				description: "For Questions Relating To Admissions And Withdrawals",
				Icon: Icon.Files,
				iconColor: "var(--theme-colors__purple)",
				iconBackgroundColor: "var(--theme-colors__purple--background)",
				members: [
					{
						description: "Admissions And Withdrawals",
						email: "olivia.musat@verita.ro",
					},
				],
			},
			{
				id: "Miscellaneous & Other",
				name: "Miscellaneous & Other",
				description: "For Any Feedback, Question, Comment Or Miscellaneous That ",
				Icon: Icon.PlusCircle,
				iconColor: "var(--theme-colors__blue)",
				iconBackgroundColor: "var(--theme-colors__blue--background)",
				members: [
					{
						description: "",
						email: "luiza.joita@verita.ro",
					},
				],
			},
		];
	}

	if (projectName === "verita-greece") {
		return [
			{
				id: "General",
				name: "General",
				description: "For General Questions, Comments, Feedback And Requests",
				Icon: Icon.Question,
				iconColor: "var(--theme-colors__blue)",
				iconBackgroundColor: "var(--theme-colors__blue--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "debbie@veritaschool.gr",
					},
					{
						description: "Early Years School",
						email: "despina@veritaschool.gr",
					},
				],
			},
			{
				id: "Education",
				name: "Education",
				description: "For Questions Relating To Educational Policies, Issues, Organization And Routines",
				Icon: Icon.Exam,
				iconColor: "var(--theme-colors__orange)",
				iconBackgroundColor: "var(--theme-colors__orange--background)",
				members: [
					{
						description: "Early Years School",
						email: "cobi@veritaschool.gr",
					},
					{
						description: "Primary School",
						email: "damian@veritaschool.gr",
					},
					{
						description: "Secondary School",
						email: "georgev@veritaschool.gr",
					},
					{
						description: "Curriculum",
						email: "annat@veritaschool.gr",
					},
				],
			},
			{
				id: "Financial",
				name: "Financial",
				description: "For Questions Relating To General Finance And Payments",
				Icon: Icon.Bank,
				iconColor: "var(--theme-colors__green)",
				iconBackgroundColor: "var(--theme-colors__green--background)",
				members: [
					{
						description: "Finance, Payments And Accounting",
						email: "george@veritaschool.gr",
					},
					{
						description: "Operations",
						email: "romina@veritaschool.gr",
					},
				],
			},
			{
				id: "Curriculum",
				name: "Curriculum",
				description: "For Questions Regarding Curriculum, Syllabus, Content And Misc.",
				Icon: Icon.BookOpenText,
				iconColor: "var(--theme-colors__yellow)",
				iconBackgroundColor: "var(--theme-colors__yellow--background)",
				members: [
					{
						description: "Curriculum",
						email: "annat@veritaschool.gr",
					},
					{
						description: "Early Years School",
						email: "cobi@veritaschool.gr",
					},
					{
						description: "Primary School",
						email: "damian@veritaschool.gr",
					},
					{
						description: "Secondary School",
						email: "georgev@veritaschool.gr",
					},
				],
			},
			{
				id: "Guidance & Counseling",
				name: "Guidance & Counseling",
				description: "For Questions Relating To General Counseling, College Counseling And Guidance Counseling",
				Icon: Icon.Compass,
				iconColor: "var(--theme-colors__purple)",
				iconBackgroundColor: "var(--theme-colors__purple--background)",
				members: [
					{
						description: "SEL Director",
						email: "demy@veritaschool.gr",
					},
					{
						description: "SEL Support",
						email: "montana@veritaschool.gr",
					},
					{
						description: "Learning Support",
						email: "irinig@veritaschool.gr",
					},
				],
			},
			{
				id: "SEL & Learning Support",
				name: "SEL & Learning Support",
				description: "For Questions And Support Regarding Social Emotional Or General Learning",
				Icon: Icon.FlowerLotus,
				iconColor: "var(--theme-colors__teal)",
				iconBackgroundColor: "var(--theme-colors__teal--background)",
				members: [
					{
						description: "SEL Director",
						email: "demy@veritaschool.gr",
					},
					{
						description: "SEL Support",
						email: "montana@veritaschool.gr",
					},
					{
						description: "Learning Support",
						email: "irinig@veritaschool.gr",
					},
				],
			},
			{
				id: "After-School",
				name: "After-School",
				description: "For Questions Relating To After School Activities",
				Icon: Icon.SoccerBall,
				iconColor: "var(--theme-colors__orange)",
				iconBackgroundColor: "var(--theme-colors__orange--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "debbie@veritaschool.gr",
					},
					{
						description: "Early Years School",
						email: "despina@veritaschool.gr",
					},
				],
			},

			{
				id: "Transportation",
				name: "Transportation",
				description: "For Questions Relating To Transportation",
				Icon: Icon.Van,
				iconColor: "var(--theme-colors__blue)",
				iconBackgroundColor: "var(--theme-colors__blue--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "debbie@veritaschool.gr",
					},
					{
						description: "Bus Coordinator",
						email: "nina@veritaschool.gr",
					},
				],
			},
			{
				id: "Health",
				name: "Health",
				description: "For Questions Relating To Health And Health Issues",
				Icon: Icon.FirstAidKit,
				iconColor: "var(--theme-colors__pink)",
				iconBackgroundColor: "var(--theme-colors__pink--background)",
				members: [
					{
						description: "Primary and Secondary Nurse",
						email: "vicky@veritaschool.gr",
					},
					{
						description: "Health and Wellness Director",
						email: "alison@veritaschool.gr",
					},
				],
			},
			{
				id: "Food",
				name: "Food",
				description: "For Questions Regarding Food, Meal Menus And Misc.",
				Icon: Icon.ForkKnife,
				iconColor: "var(--theme-colors__orange)",
				iconBackgroundColor: "var(--theme-colors__orange--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "debbie@veritaschool.gr",
					},
					{
						description: "Early Years School",
						email: "despina@veritaschool.gr",
					},
					{
						description: "Operations",
						email: "romina@veritaschool.gr",
					},
				],
			},
			{
				id: "Technology",
				name: "Technology",
				description: "For Questions Relating To Technology Policies, Hardware Advice And General Troubleshooting",
				Icon: Icon.Desktop,
				iconColor: "var(--theme-colors__teal)",
				iconBackgroundColor: "var(--theme-colors__teal--background)",
				members: [
					{
						description: "Verita Portal Troubleshooting & Feedback ",
						email: "jett@hexinsights.com",
					},
					{
						description: "General I.T & Technology",
						email: "lazaros@veritaschool.gr",
					},
				],
			},
			{
				id: "Admissions & Withdrawals",
				name: "Admissions & Withdrawals",
				description: "For Questions Relating To Admissions And Withdrawals",
				Icon: Icon.Files,
				iconColor: "var(--theme-colors__purple)",
				iconBackgroundColor: "var(--theme-colors__purple--background)",
				members: [
					{
						description: "Admissions And Withdrawals",
						email: "eirini@veritaschool.gr",
					},
				],
			},
			{
				id: "Miscellaneous & Other",
				name: "Miscellaneous & Other",
				description: "For Any Feedback, Question, Comment Or Miscellaneous That ",
				Icon: Icon.PlusCircle,
				iconColor: "var(--theme-colors__blue)",
				iconBackgroundColor: "var(--theme-colors__blue--background)",
				members: [
					{
						description: "Primary And Secondary School",
						email: "debbie@veritaschool.gr",
					},
					{
						description: "Early Years School",
						email: "despina@veritaschool.gr",
					},
					{
						description: "Operations",
						email: "romina@veritaschool.gr",
					},
				],
			},
		];
	}

	return [];
})();
